import {Component, OnInit} from '@angular/core';
import {environment} from 'environments/environment';
import {AuthStateService, ErrorHandlerService, ToastService, TokenService, UserService} from './core/services';
import {filter, mergeMap, takeWhile} from 'rxjs/operators';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {logging} from "protractor";
import {EMPTY} from "rxjs";
import {setOptions} from '@mobiscroll/angular';
import {LinkService} from "./core/services/link.service";


setOptions({
  theme: 'ios',
  themeVariant: 'light',
});


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  isAuthenticated = false;
  passwordReset = false;
  isProcessing = false;

  constructor(private router: Router,
              private toastService: ToastService,
              private _errorHandlerService: ErrorHandlerService,
              private linkService : LinkService,
              private _userService: UserService,
              private activatedRoute : ActivatedRoute
  ) {
    AuthStateService.loadToken().then();
    this.isAuthenticated = AuthStateService.isTokenActive();
  }

  ngOnInit() {
    this.checkUrlForFirstLoginFlag();
    console.log('this  is running')
    this.linkService.addPreconnectLink(environment.baseUrl);
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(
      e => {
        this.isAuthenticated = AuthStateService.isTokenActive();
      });
  }



  checkUrlForFirstLoginFlag() {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      const firstLoginFlag = params['first_login'];
      if (firstLoginFlag) {
        await this._userService.forceSetFirstLoginFlag(firstLoginFlag === 'true');
        this.router.navigate([],{
          queryParams : {'first_login' : null},
          queryParamsHandling : 'merge',
          replaceUrl : true
        })
      }
    });
  }

  private _checkVerifyURL(event) {
    if (event.url.indexOf("verify") === -1) {
      if (
        this.isAuthenticated &&
        !sessionStorage.getItem("fetchUser")
      ) {
        sessionStorage.setItem("fetchUser", "true");
        return this._userService.getUserDetail();
      }
      return EMPTY;
    }
    return EMPTY;
  }
}
